module.exports = __webpack_public_path__ + "img/bullhorn.bcfb34f5.svg";